import { ELSCommonConfig } from '../els.components';

const ecaApplicationIdNonProd = '027c23c4-76f4-4ddf-b8fd-7dbb5d342018';
const ecaApplicationIdNonProdStage = 'da4eae8f-ce9d-49ab-8e00-2aa666b9fdf6';
const ecaApplicationIdProd = '6ca75a0e-9dec-4e2f-a5c0-9afe32dfd51d';
const stageGatewayURL = 'https://eolsapi-stage.apps.els-ols.com';
const qaContentBaseURL = 'https://content-qa.els-ols.com';
const lowerEnvCookiesDomain = '.apps.els-ols.com';
// AI Course Builder service — bypasses eols-gateway to avoid 50s timeout on LLM calls.
const aiServiceUrl = (env: string) => `https://nhe-courseware-ai-service-${env}.apps.els-ols.com`;
const aiServiceUrlProd = 'https://nhe-courseware-ai-service.elsevier.com';
const lowerEvolveCartURL = 'https://evolvetest.elsevier.com/cs/lms';
const evolveCartURL = 'https://evolve.elsevier.com/cs/lms';
const myEvolveUrlLower = 'https://evolvetest.elsevier.com/cs/myEvolve';
const myEvolveUrlProd = 'https://evolve.elsevier.com/cs/myEvolve';
const myEvolveAccountUrlLower = 'https://evolvetest.elsevier.com/cs/account';
const myEvolveAccountUrlProd = 'https://evolve.elsevier.com/cs/account';

export const ServerConstants = {
  DataSource: ELSCommonConfig.appProfile, // Replace with the preferred source from below.

  dev: {
    //  'Dev'
    gatewayBaseURL: 'https://eolsapi-dev.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('dev'),
    contentBaseURL: 'https://content-dev.els-ols.com/dev',
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  qa: {
    //  'QA'
    gatewayBaseURL: 'https://qa-apigateway-eols.elsevier.com',
    aiServiceBaseURL: aiServiceUrl('qa'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  demo: {
    //  'Demo'
    gatewayBaseURL: 'https://eolsapi-demo.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('demo'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  test1: {
    gatewayBaseURL: 'https://eolsapi-test1.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('test1'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  test2: {
    gatewayBaseURL: 'https://eolsapi-test2.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('test2'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  test3: {
    gatewayBaseURL: 'https://eolsapi-test3.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('test3'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  test4: {
    gatewayBaseURL: 'https://eolsapi-test4.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('test4'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  test5: {
    gatewayBaseURL: 'https://eolsapi-test5.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('test5'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  test6: {
    gatewayBaseURL: 'https://eolsapi-test6.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('test6'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  test7: {
    gatewayBaseURL: 'https://eolsapi-test7.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('test7'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  'ck-cert': {
    // test7
    gatewayBaseURL: 'https://eolsapi-test7.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('test7'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  'cd-staging': {
    // stage
    gatewayBaseURL: stageGatewayURL,
    aiServiceBaseURL: aiServiceUrl('stage'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProdStage,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  staging: {
    // stage
    gatewayBaseURL: stageGatewayURL,
    aiServiceBaseURL: aiServiceUrl('stage'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProdStage,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  stage: {
    gatewayBaseURL: stageGatewayURL,
    aiServiceBaseURL: aiServiceUrl('stage'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: 'https://evolvestage.elsevier.com/cs/myEvolve',
    myEvolveAccountUrl: 'https://evolvestage.elsevier.com/cs/account',
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProdStage,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  stage1: {
    gatewayBaseURL: 'https://eolsapi-stage1.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('stage1'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProdStage,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  stage2: {
    gatewayBaseURL: 'https://eolsapi-stage2.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('stage2'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProdStage,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  validate: {
    gatewayBaseURL: 'https://eolsapi-validate.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('validate'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: 'validate',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  vendor: {
    gatewayBaseURL: 'https://eolsapi-vendor.apps.els-ols.com',
    aiServiceBaseURL: aiServiceUrl('vendor'),
    contentBaseURL: qaContentBaseURL,
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  perf: {
    //  'Perf environment
    gatewayBaseURL: 'https://eolsapi-perf.apps.elsevier.education',
    aiServiceBaseURL: aiServiceUrl('perf'),
    contentBaseURL: 'https://content-perf.apps.elsevier.education',
    cookiesDomain: lowerEnvCookiesDomain,
    evolveCartURL: lowerEvolveCartURL,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  betaprod: {
    //  'Prod
    gatewayBaseURL: 'https://eolsapi-betaprod.apps.elsevier.education',
    aiServiceBaseURL: aiServiceUrlProd,
    contentBaseURL: 'https://content-betaprod.apps.elsevier.education',
    evolveCartURL: lowerEvolveCartURL,
    cookiesDomain: lowerEnvCookiesDomain,
    myEvolveUrl: myEvolveUrlLower,
    myEvolveAccountUrl: myEvolveAccountUrlLower,
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdNonProd,
    config: {
      PushEventsEnabled: true,
      PushEventsUsesGateway: true,
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  },
  prod: {
    //  'Prod
    gatewayBaseURL: 'https://eolsapi.elsevier.com',
    aiServiceBaseURL: aiServiceUrlProd,
    contentBaseURL: 'https://eolscontent.elsevier.com',
    evolveCartURL,
    myEvolveUrl: myEvolveUrlProd,
    myEvolveAccountUrl: myEvolveAccountUrlProd,
    cookiesDomain: '.elsevier.com',
    eolsEnv: '',
    ecaApplicationId: ecaApplicationIdProd,
    config: {
      TokenServiceEnabled: true, // toggle for enabling token service integration
      CORSAllowCredentials: true, // toggle to turn on allow-credentials needed for Amazon S3 Cloud Front Cookies
      EnableLogging: true
    }
  }
};
